<template>
	<div class="order-body">
		<div class="fx-header goback">
            <p>运费</p>
        </div>
		<el-tabs v-model="activeName" @tab-click="tabChange">
			<el-tab-pane label="运费设置" name="first"></el-tab-pane>
			<el-tab-pane label="运费模板设置" name="second"></el-tab-pane>
		</el-tabs>
		<div class="order-body" style="min-height:0" v-show="activeName === 'first'">
			<Search :ids="ids" :customList="customList" :tableData='tableData' :AuthorityList='AuthorityList' ref='searchRef' @handleSearch="handleSearch" @modifySuc="modifySuc"/>
			<MainTable
				ref='table'
				:size='size'
				:page='page'
				:tableData='tableData'
				:totalCount='totalCount'
				:AuthorityList='AuthorityList'
				@modifySuc="modifySuc"
				@handleSize='handleSizeChange'
				@handlePage='handlePageChange'
				@selectIds="selectIdsChange"
			/>
		</div>
		<div class="order-body" style="min-height:0" v-show="activeName === 'second'">
			<div style="text-align:left">
				<el-dropdown @command="handleCommand">
					<el-button type="primary" size="small" plain>
						新增运费模板<i class="el-icon-arrow-down el-icon--right"></i>
					</el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="regular">常规模板</el-dropdown-item>
						<el-dropdown-item command="special">特殊商品计费模板</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
			<div class="type-box">
				<div>
					<el-radio-group v-model="templateType" size="small" @change="templateSearch">
						<el-radio-button :label="-1">全部模板({{temTotalCount}})</el-radio-button>
						<el-radio-button :label="0">整单运费({{temNormalCount}})</el-radio-button>
						<el-radio-button :label="1">特殊商品运费({{temSpecCount}})</el-radio-button>
					</el-radio-group>
				</div>
				<div style="width:250px">
					<el-input
						v-model="templateName"
						placeholder="搜索"
						size="small"
						@keyup.enter.native="templateSearch">
						<el-button slot="append" icon="el-icon-search" @click="templateSearch"></el-button>
					</el-input>
				</div>
			</div>
			<div class="template-list">
				<div class="template-li" v-for="(item, index) in templateList" :key="item.id" @click="toggleTemplate(item, index)">
					<div class="template-head">
						<img src="~/images/icon/special-icon.png" v-if="item.type === 1">
						<span class="span-one">{{item.name}}</span>
						<span style="margin:0 10px" v-if="item.freeflag">
							参与免运费（
							<span v-if="item.freearea === 1"> 限区域 </span>
							<span v-if="item.freearea === 0">
								不限区域订单商品金额满{{ item.freemoney }}元
							</span>
							）
						</span>
						<span class="span-four">赠品{{item.calcgiftFlag ? '' : '不'}}计算运费</span>
						<img src="~/images/icon/checkbox-sel.png" v-if="item.defaultFlag">
						<span class="span-five" v-if="item.defaultFlag">默认模板</span>
						<div class="head-right">
							<span class="span-six">最后编辑时间:{{item.modifyDate}}</span>
							<el-button type='text' size="mini" @click.stop="setDefault(item)" v-if="AuthorityList['01_0003_0001_00'] && !item.defaultFlag">设为默认模板</el-button>
							<el-button type='text' size="mini" @click.stop="cancelDefault(item)" v-if="AuthorityList['01_0003_0001_00'] && item.defaultFlag">取消默认模板</el-button>
							<el-button type='text' size="mini" @click.stop="copyTemplate(item.id)" v-if="AuthorityList['01_0003_0001_00']">复制模板</el-button>
							<el-button type='text' size="mini" @click.stop="modifyTemplate(item)" v-if="AuthorityList['01_0003_0001_00']">修改</el-button>
							<el-button type='text' size="mini" @click.stop="deleteTemplate(item)" v-if="AuthorityList['01_0003_0001_00']">删除</el-button>
						</div>
					</div>
					<div class="template-content" v-show="item.showFlag">
						<div v-if="item.type === 0">
							<el-table
								class="grid-content"
								:data="item.detailList"
								max-height="180"
								size="mini"
								ref="table"
								:span-method="objectSpanMethod"
							>
								<el-table-column
									prop="staffName"
									label="配送区域">
									<template slot-scope="scope">
										<el-tooltip effect="dark" :content="scope.row.areaname" placement="top-start">
											<div class="over-hidden">{{scope.row.showname}}</div>
										</el-tooltip>
									</template>
								</el-table-column>
								<el-table-column
									prop="freemoney"
									v-if="item.freeflag && item.freearea === 1"
									label="免运费规则"
									align="center">
									<template slot-scope="scope">
										<div>
											订单商品金额满{{ scope.row.freemoney }}元免运费
										</div>
									</template>
								</el-table-column>
								<el-table-column
									prop="transportMode"
									label="运输方式"
									align="center">
									<template slot-scope="scope">
										<div>
											<div v-if="scope.row.transportMode === 0">不限</div>
											<div v-if="scope.row.transportMode === 1">常温运输</div>
											<div v-if="scope.row.transportMode === 2">冷链运输</div>
										</div>
									</template>
								</el-table-column>
								<el-table-column
									prop="pricingType"
									label="计费方式">
									<template slot-scope="scope">
										<div class="over-hidden" v-if="scope.row.pricingType === 0">一口价</div>
										<div class="over-hidden" v-if="scope.row.pricingType === 1">阶梯价</div>
										<div class="over-hidden" v-if="scope.row.pricingType === 2">比例价</div>
										<div class="over-hidden" v-if="scope.row.pricingType === 5">固定件数</div>
										<div class="over-hidden" v-if="scope.row.pricingType === 6">阶梯件数</div>
										<div class="over-hidden" v-if="scope.row.pricingType === 7">固定重量</div>
										<div class="over-hidden" v-if="scope.row.pricingType === 9">阶梯件数：超出起步价部分，每件</div>
										<div class="over-hidden" v-if="scope.row.pricingType === 10">阶梯件数：超出起步价部分，一律每件</div>
									</template>
								</el-table-column>
								<el-table-column
									prop="itemCount"
									label="计费规则">
									<template slot-scope="scope">
										<div class="flex-two">
											<div class="rule-box" v-if="scope.row.pricingType === 0">
												<div v-for="item in scope.row.freightTemplatePricingDTOList" :key="item.id">一口价{{item.freightMoney}}元</div>
											</div>
											<div class="rule-box two-box" v-if="scope.row.pricingType === 1">
												<div v-for="(childItem, childIndex) in scope.row.freightTemplatePricingDTOList" :key="childIndex" class="two-wrap">
													<div class="step-box">订单金额于{{childItem.minValue}}元（含）~{{childItem.maxValue}}元（不含）
													，收{{childItem.freightMoney}}元</div>
												</div>
											</div>
											<div class="rule-box" style="display:flex;align-items:center;" v-if="scope.row.pricingType === 2">
												<div v-for="item in scope.row.freightTemplatePricingDTOList" :key="item.id">订单金额比例的{{item.percentMoney}}%</div>
											</div>
											<div class="rule-box" style="display:flex;align-items:center;" v-if="scope.row.pricingType === 5">
												<div v-for="item in scope.row.freightTemplatePricingDTOList" :key="item.id">首费：{{item.maxValue}}件（包含及以下）,{{item.freightMoney}}元；续费：超出每件{{item.stepMoney}}元；{{item.topOffValue ? '封顶' + item.topOffValue + '件' : '无封顶'}}</div>
											</div>
											<div class="rule-box two-box" v-if="scope.row.pricingType === 6">
												<div v-for="(childItem, childIndex) in scope.row.freightTemplatePricingDTOList" :key="childIndex" class="two-wrap">
													<div class="step-box">订单件数于{{childItem.minValue}}件（含）~{{childItem.maxValue}}件（不含）
													，收{{childItem.freightMoney}}元</div>
												</div>
											</div>
											<div class="rule-box" style="display:flex;align-items:center;" v-if="scope.row.pricingType === 7">
												<div v-for="item in scope.row.freightTemplatePricingDTOList" :key="item.id">首费：{{item.maxValue}}KG（包含及以下）,{{item.freightMoney}}元；续费：超出每KG{{item.stepMoney}}元；{{item.topOffValue ? '封顶' + item.topOffValue + 'KG' : '无封顶'}}</div>
											</div>
											<div class="rule-box two-box" v-if="scope.row.pricingType === 9">
												<template>
													<div v-for="(childItem, childIndex) in scope.row.freightTemplatePricingDTOList" :key="childIndex" class="two-wrap">
														<div v-if="childIndex === 0" class="step-box">{{childItem.minValue}} ~ {{childItem.maxValue}} 件（不含），运费固定 {{childItem.freightMoney}} 元，{{ scope.row.detailtype === 1 ? '超出起送件数，超出部分每件' : '超出起送件数，每件' }}</div>
														<div v-else class="step-box">{{childItem.minValue}} ~ {{childItem.maxValue}} 件（不含），按照每件 {{childItem.freightMoney}} 元收取</div>
													</div>
												</template>
											</div>
											<div class="rule-box" style="display:flex;align-items:center;" v-if="scope.row.pricingType === 10">
												<div v-for="item in scope.row.freightTemplatePricingDTOList" :key="item.id">
													0-{{item.maxValue}}件，起步价{{item.freightMoney}}元，只要超出起步件数，一律按照每件{{item.stepMoney}}元收取
												</div>
											</div>
										</div>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div v-if="item.type === 1">
							<el-table
								class="grid-content"
								:data="item.detailList"
								max-height="250"
								ref="table2"
								:span-method="objectSpanMethod"
							>
								<el-table-column
									prop="showname"
									label="配送区域"
									min-width="300"
									align="center">
									<template slot-scope="scope">
										<div :title="scope.row.areaname">{{scope.row.showname}}</div>
									</template>
								</el-table-column>
								<el-table-column
									prop="productName"
									label="商品"
									align="center">
								</el-table-column>
								<el-table-column
									prop="transportMode"
									label="运输方式"
									align="center">
									<template slot-scope="scope">
										<div>
											<div v-if="scope.row.transportMode === 0">不限</div>
											<div v-if="scope.row.transportMode === 1">常温运输</div>
											<div v-if="scope.row.transportMode === 2">冷链运输</div>
										</div>
									</template>
								</el-table-column>
								<el-table-column
									prop="productAttrplanName"
									label="规格"
									align="center">
								</el-table-column>
								<el-table-column
									prop="pricingType"
									label="计费方式"
									align="center">
									<template slot-scope="scope">
										<div>
											<div v-if="scope.row.pricingType === 3">计重</div>
											<div v-if="scope.row.pricingType === 8">计件：固定件数</div>
											<div v-if="scope.row.pricingType === 4">计件：阶梯件数</div>
										</div>
									</template>
								</el-table-column>
								<el-table-column
									prop="pricingType"
									label="计费规则"
									min-width="400"
									align="center">
									<template slot-scope="scope">
										<div class="flex-two table-box">
											<div v-if="scope.row.pricingType === 4" style="text-align:left">
												<div class="rule-box two-box">
													<div v-for="(childItem, childIndex) in scope.row.freightTemplatePricingDTOList" :key="childIndex" class="two-wrap">
														<div class="step-box">
															商品于{{childItem.minValue}}件（不含）~{{childItem.maxValue}}件（不含），收
															{{childItem.freightMoney}}元</div>
													</div>
													<div v-if="scope.row.freeMoney">该商品金额满{{scope.row.freeMoney}}元，免运费。</div>
												</div>
											</div>
											<div v-if="scope.row.pricingType === 3" style="text-align:left">
												商品于0kg（含）~{{scope.row.freightTemplatePricingDTOList[0].maxValue}}kg（含），收{{scope.row.freightTemplatePricingDTOList[0].freightMoney}}
												元，每增加{{scope.row.freightTemplatePricingDTOList[0].stepValue}}kg，加收
												{{scope.row.freightTemplatePricingDTOList[0].stepMoney}}元
												<div v-if="scope.row.freeMoney">该商品金额满{{scope.row.freeMoney}}元，免运费。</div>
											</div>
											<div v-if="scope.row.pricingType === 8" style="text-align:left">
												商品于0件（含）~{{scope.row.freightTemplatePricingDTOList[0].maxValue}}件（含），收{{scope.row.freightTemplatePricingDTOList[0].freightMoney}}
												元，每增加{{scope.row.freightTemplatePricingDTOList[0].stepValue}}件，加收
												{{scope.row.freightTemplatePricingDTOList[0].stepMoney}}元
												<div v-if="scope.row.freeMoney">该商品金额满{{scope.row.freeMoney}}元，免运费。</div>
											</div>
										</div>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Search from '@/components/freight/SearchNew.vue'
import MainTable from '@/components/freight/MainTable.vue'
export default {
	name: 'freight',
	components: {
		Search,
		MainTable
	},
	data () {
		return {
			AuthorityList: {
				'01_0003_0001_00': false,
				'01_0003_0002_00': false,
				'01_0003_0003_00': false,
				'01_0003_0004_00': false
			},
			page: 1,
			size: 20,
			tableData: [],
			totalCount: 0,
			ids: [],
			customList: [],
			disabledflag: -1,
			shop: [],
			customer: [],
			category: [],
			level: [],
			normal: [],
			special: [],
			shopCategoryBigId: '0',
			shopCategorySmallId: '0',
			product: '',
			spec: '',
			activeName: 'first',
			templateType: -1,
			templateName: '',
			temTotalCount: 0,
			temNormalCount: 0,
			temSpecCount: 0,
			templateList: [],
			filterArr: ['1278045867575746560', '1284199491759906816', '720926033251270656'],
			filterFlag: false
		}
	},
	created () {
		this.$fxEventBus.$emit('setMenu', '2-4')
		this.getAuthority('01_0003_0000_00')
		const syscodeid = window.sessionStorage.getItem('entid')
		this.filterFlag = this.filterArr.includes(syscodeid)
		if (this.$route.query.shopid) {
			this.shop = [this.$route.query.shopid]
		}
		this.activeName = window.sessionStorage.getItem('freightTab') || 'first'
		if (this.activeName === 'first') {
			this.openPage()
		} else {
			if (window.sessionStorage.getItem('freightTemplateSelect')) {
				let data = JSON.parse(window.sessionStorage.getItem('freightTemplateSelect'))
				this.templateName = data.name
				this.templateType = data.type
			}
			this.getTemplate()
		}
	},
	methods: {
		handleCommand (e) {
			if (e === 'regular') {
				this.$router.push(`/main/freightEdit`)
			} else {
				this.$router.push(`/main/freightSpecial`)
			}
		},
		modifyTemplate (row) {
			if (row.type === 0) {
				this.$router.push({ path: '/main/freightEdit', query: { id: row.id } })
			} else {
				this.$router.push({ path: '/main/freightSpecial', query: { id: row.id } })
			}
		},
		tabChange (e) {
			window.sessionStorage.setItem('freightTab', e.name)
			if (e.name === 'first') {
				this.findOrderList()
			} else {
				if (window.sessionStorage.getItem('freightTemplateSelect')) {
					let data = JSON.parse(window.sessionStorage.getItem('freightTemplateSelect'))
					this.templateName = data.name
					this.templateType = data.type
				}
				this.getTemplate()
			}
		},
		toggleTemplate (item, index) {
			if (item.detailList.length !== 0) {
				item.showFlag = !item.showFlag
			} else {
				let params = {
					id: item.id
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlSV}/order/freightTemplate/detail/get`,
					data: params
				}).then(res => {
					if (res.result === true) {
						if (item.type === 0) {
							let arr = []
							res.data.freightTemplateDetailDTOList.forEach(e => {
								if (e.areaname.split(',').length > 20) {
									e.showname = e.areaname.split(',').slice(0, 21).join(',') + '...'
								} else {
									e.showname = e.areaname
								}
								e.freemoney = this.$fxUtils.toFixedSHW(e.freemoney, 2)
								if (e.freightTemplatePricingDetail !== null) {
									let row = {}
									let dto = []
									e.freightTemplatePricingDetail.freightTemplatePricingDTOList.forEach(item => {
										row.freemoney = e.freemoney
										row.showname = e.showname
										row.areaname = e.areaname
										row.transportMode = 0
										row.pricingType = e.freightTemplatePricingDetail.pricingType
										row.detailtype = e.freightTemplatePricingDetail.detailtype
										item.freightMoney = this.$fxUtils.toFixedSHW(item.freightMoney, 2)
										item.percentMoney = this.$fxUtils.toFixedSHW(item.freightRatio, 2)
										if (item.pricingType !== 5 && item.pricingType !== 6) {
											item.minValue = this.$fxUtils.toFixedSHW(item.minValue, 2)
											item.maxValue = item.maxValue === null ? '' : this.$fxUtils.toFixedSHW(item.maxValue, 2)
										}
										dto.push(item)
									})
									row.freightTemplatePricingDTOList = dto
									arr.push(row)
								}
								if (e.simpleTemplatePricingDetail !== null) {
									let row = {}
									let dto = []
									e.simpleTemplatePricingDetail.freightTemplatePricingDTOList.forEach(item => {
										row.freemoney = e.freemoney
										row.showname = e.showname
										row.areaname = e.areaname
										row.pricingType = e.simpleTemplatePricingDetail.pricingType
										row.detailtype = e.simpleTemplatePricingDetail.detailtype
										row.transportMode = 1
										item.freightMoney = this.$fxUtils.toFixedSHW(item.freightMoney, 2)
										item.percentMoney = this.$fxUtils.toFixedSHW(item.freightRatio, 2)
										if (item.pricingType !== 5 && item.pricingType !== 6) {
											item.minValue = this.$fxUtils.toFixedSHW(item.minValue, 2)
											item.maxValue = item.maxValue === null ? '' : this.$fxUtils.toFixedSHW(item.maxValue, 2)
										}
										dto.push(item)
									})
									row.freightTemplatePricingDTOList = dto
									arr.push(row)
								}
								if (e.coldChainTemplatePricingDetail !== null) {
									let row = {}
									let dto = []
									e.coldChainTemplatePricingDetail.freightTemplatePricingDTOList.forEach(item => {
										row.freemoney = e.freemoney
										row.showname = e.showname
										row.areaname = e.areaname
										row.transportMode = 2
										row.pricingType = e.coldChainTemplatePricingDetail.pricingType
										row.detailtype = e.coldChainTemplatePricingDetail.detailtype
										item.freightMoney = this.$fxUtils.toFixedSHW(item.freightMoney, 2)
										item.percentMoney = this.$fxUtils.toFixedSHW(item.freightRatio, 2)
										if (item.pricingType !== 5 && item.pricingType !== 6) {
											item.minValue = this.$fxUtils.toFixedSHW(item.minValue, 2)
											item.maxValue = item.maxValue === null ? '' : this.$fxUtils.toFixedSHW(item.maxValue, 2)
										}
										dto.push(item)
									})
									row.freightTemplatePricingDTOList = dto
									arr.push(row)
								}
							})
							item.detailList = arr
							this.colspanData(index)
						}
						if (item.type === 1) {
							// let newList = []
							res.data.freightTemplateProductAttrplanDTOList.forEach(item => {
								let nameArr = item.areaname.split(',')
								item.showname = item.areaname
								if (nameArr.length > 20) {
									item.showname = nameArr.slice(0, 21).join(',') + '...'
								}
								item.freeMoney = item.freightTemplatePricingDTOList[0].freeMoney
								item.topOffRadio = item.freeMoney === null ? '1' : '2'
								item.colspan = 1
								item.firstCol = true
							})
							item.detailList = res.data.freightTemplateProductAttrplanDTOList
							this.colspanData(index)
						}
						// }
						item.showFlag = !item.showFlag
					}
				})
			}
		},
		colspanData (index) {
			let copyData = this.sortClass(this.templateList[index].detailList)
			copyData.forEach(item => {
				if (item.length === 1) {
					item[0].colspan = 1
					item[0].firstCol = true
				} else {
					let num = 0
					let index = 0
					item.forEach((e, eIndex) => {
						e.colspan = 1
						e.firstCol = false
						// if (e.searchShow) {
						item[index].colspan = item[index].colspan + num
						if (num === 0) {
							if (eIndex === item.length - 1) {
								e.firstCol = true
							} else {
								index = eIndex
								num = 1
							}
						}
						// }
					})
				}
			})
			let finalData = []
			copyData.forEach(item => {
				finalData.push(...item)
			})
			this.templateList[index].detailList = finalData
		},
		sortClass (sortData) {
			const groupBy = (array, f) => {
				let groups = {}
				array.forEach((o) => {
					let group = JSON.stringify(f(o))
					groups[group] = groups[group] || []
					groups[group].push(o)
				})
				return Object.keys(groups).map((group) => {
					return groups[group]
				})
			}
			const sorted = groupBy(sortData, (item) => {
				return item.areaname // 返回需要分组的对象
			})
			return sorted
		},
		objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
			if (column.property === 'freemoney') {
				if (row.firstCol) {
					return {
						rowspan: 1,
						colspan: 1
					}
				} else if (row.colspan && row.colspan !== 1) {
					return {
						rowspan: row.colspan,
						colspan: 1
					}
				} else {
					return {
						rowspan: 0,
						colspan: 0
					}
				}
			}
			if (columnIndex === 0) {
				if (row.firstCol) {
					return {
						rowspan: 1,
						colspan: 1
					}
				} else if (row.colspan && row.colspan !== 1) {
					return {
						rowspan: row.colspan,
						colspan: 1
					}
				} else {
					return {
						rowspan: 0,
						colspan: 0
					}
				}
			}
		},
		deleteTemplate (row) {
			if (row.defaultFlag) {
				this.$alert('请更换默认模板后,再删除', '该模板为默认模板,无法删除', {
					confirmButtonText: '确定',
					callback: action => {}
				})
				return false
			}
			let that = this
			this.$confirm('删除将不可恢复, 是否删除?', '提示', {
				confirmButtonText: '删除',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let logger
				logger = this.$fxLogger.createInfo('seller.freight.delete', { name: row.name })
				let params = {
					id: row.id,
					type: row.type
				}
				that.$store.dispatch('requestPost', {
					url: `${that.$fxBaseApi.urlQIVShop}/freightTemplate/remove`,
					data: params,
					logger
				}).then(res => {
					if (res.result === true) {
						that.$message.success('删除成功')
						that.getTemplate()
					} else {
						that.$message.error(res.msg)
					}
				})
			}).catch(() => {})
		},
		setDefault (row) {
			let that = this
			let text = `默认模板将更换为"${row.name}",新门店或新客户若未设置运费,则应用默认模板的计费方式`
			this.$confirm(text, '是否更换默认模板', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let params = {
					id: row.id
				}
				that.$store.dispatch('requestPost', {
					url: `${that.$fxBaseApi.urlQIVShop}/freightTemplate/updateDefault`,
					data: params
				}).then(res => {
					if (res.result === true) {
						that.$message.success('设置成功')
						that.getTemplate()
					} else {
						that.$message.error(res.msg)
					}
				})
			}).catch(() => {})
		},
		cancelDefault (row) {
			let params = {
				id: row.id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/freightTemplate/updateUndefault`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.$message.success('取消成功')
					this.getTemplate()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		copyTemplate (id) {
			let params = {
				id: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/freightTemplate/copy`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.$message.success('复制成功')
					this.getTemplate()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		selectIdsChange (ids) {
			this.ids = ids
		},
		saveSelect () {
			let params = {
				shop: this.shop,
				category: this.category,
				level: this.level,
				normal: this.normal,
				customer: this.customer,
				product: this.product,
				special: this.special,
				page: this.page,
				size: this.size
			}
			window.sessionStorage.setItem('freightSelect', JSON.stringify(params))
		},
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		// 客户类别
		getCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/list`
			}).then(res => {
				if (res.result === true) {
					this.customList = res.data.childNode
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		openPage () {
			if (window.sessionStorage.getItem('freightSelect') && !this.filterFlag) {
				let data = JSON.parse(window.sessionStorage.getItem('freightSelect'))
				this.shop = data.shop
				this.category = data.category
				this.level = data.level
				this.normal = data.normal
				this.customer = data.customer
				this.product = data.product
				this.special = data.special
				this.page = data.page
				this.size = data.size
			}
			this.getCategory()
			this.findOrderList()
		},
		modifySuc () {
			// this.$refs.table.clear()
			this.ids = []
			this.findOrderList()
		},
		handleSizeChange (value) {
			this.size = value
			this.page = 1
			this.findOrderList()
		},
		handlePageChange (value) {
			this.page = value
			this.findOrderList()
		},
		handleSearch (data) {
			this.shop = data.shop
			this.category = data.category
			this.level = data.level
			this.normal = data.normal
			this.customer = data.customer
			this.product = data.product
			this.special = data.special
			this.page = 1
			if (!this.filterFlag) {
				this.saveSelect()
			}
			this.findOrderList()
		},
		templateSearch () {
			let templateParams = {
				name: this.templateName,
				type: this.templateType
			}
			window.sessionStorage.setItem('freightTemplateSelect', JSON.stringify(templateParams))
			this.getTemplate()
		},
		getTemplate () {
			let params = {
				name: this.templateName,
				type: this.templateType
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/freightTemplate/list/get`,
				data: params
			}).then(res => {
				this.temTotalCount = res.data.totalFreightTemplateCount
				this.temNormalCount = res.data.normalFreightTemplateCount
				this.temSpecCount = res.data.specialProductFreightTemplateCount
				if (res.data.freightTemplateDTOList !== null) {
					res.data.freightTemplateDTOList.forEach(e => {
						e.showFlag = false
						e.detailList = []
					})
				}
				this.templateList = res.data.freightTemplateDTOList || []
			})
		},
		findOrderList () {
			this.tableData = []
			let params = {
				page: this.page,
				size: this.size,
				shopIdList: this.shop,
				customerIdList: this.customer,
				customerLevelIdList: this.level,
				customerCategoryIdList: this.category,
				freightTemplateIdList: this.normal,
				productFreightTemplateIdList: this.special,
				productName: this.product
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/relCustomerFreightTemplate/list/get`,
				data: params
			}).then(res => {
				if (res.data.list !== null) {
					res.data.list.forEach(e => {
						e.uniqueId = e.shopId + e.customerId
					})
				}
				this.totalCount = res.data.count
				this.tableData = res.data.list || []
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.order-body {
	flex: 1
	display flex
	flex-direction column
	.el-dropdown {
		vertical-align: top;
	}
	.el-dropdown + .el-dropdown {
		margin-left: 15px;
	}
	.el-icon-arrow-down {
		font-size: 12px;
	}
	.type-box {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 15px;
	}
	.template-list {
		flex: 1;
		margin-top: 15px;
		color: #333;
		overflow: hidden
		overflow-y: auto
		.template-li {
			border: 1px solid #EDEFFC;
			box-shadow: 0px 1px 4px 1px rgba(199, 199, 199, 0.23);
			border-radius: 2px;
			margin-bottom: 15px;
			.template-head {
				display: flex;
				height: 38px;
				padding: 0 10px;
				background-color: #EFEFEF;
				align-items: center;
				cursor: pointer
				img {
					width: 16px;
					height: 16px;
					margin-right: 5px;
				}
				.span-one, .span-four, .span-six {
					margin-right: 80px
				}
				.span-one {
					font-weight: bold
				}
				.span-six {
					color: #595959
				}
				.head-right {
					margin-left: auto;
				}
			}
		}
	}
}
</style>
<style lang="stylus">
.order-body {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
